import { Injectable, isDevMode } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AuthService } from '../service/auth.service'

@Injectable()
export class ApiClientService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private get requestHeader() {
    const options = this.authService.createRequestOptions()
    return options
  }

  private get requestTextHeader() {
    const options: any = this.authService.createRequestOptions()
    options.responseType = 'text'
    return options
  }

  private get requestBlobHeader() {
    const options: any = this.authService.createRequestOptions()
    options.responseType = 'blob'
    return options
  }

  private get requestHeaderPut() {
    const options = this.authService.createRequestOptions()
    options.headers = options.headers.append('Content-Type', 'application/json')
    options.headers = options.headers.append('Access-Control-Allow-Origin', '*')
    return options
  }

  private get requestHeaderDelete() {
    return this.requestHeaderPut
  }

  private get requestHeaderWithoutContentType() {
    const options = this.authService.createRequestOptions()
    options.headers = options.headers.append('Access-Control-Allow-Origin', '*')
    return options
  }

  public getTextWithPath(path: string) {
    return this.http.get<any>(`${path}`, this.requestTextHeader)
  }

  public getBlobWithPath(path: string) {
    return this.http.get<any>(`${path}`, this.requestBlobHeader)
  }

  public getWithPath(path: string) {
    return this.http.get<any>(`${path}`, this.requestHeader)
  }

  public postWithPath(path: string, body) {
    return this.http.post<any>(`${path}`, body, this.requestHeader)
  }

  public getWithPathGoogle(path: string) {
    return this.http.get<any>(
      `https://cors-anywhere.herokuapp.com/${path}`,
      this.requestTextHeader
    )
  }

  public getWithPathYoutube(path: string) {
    return this.http.get<any>(`${path}`, this.requestHeader)
  }

  public putWithPath(path: string, body) {
    return this.http.put<any>(`${path}`, body, this.requestHeaderPut)
  }

  public deleteWithPath(path: string) {
    return this.http.delete<any>(`${path}`, this.requestHeaderDelete)
  }

  public putWithoutContentType(path: string, body) {
    return this.http.put<any>(
      `${path}`,
      body,
      this.requestHeaderWithoutContentType
    )
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/api-client.service.ts